import { render, staticRenderFns } from "./RedesignExtensionCardHeader.vue?vue&type=template&id=41ea2b49"
import script from "./RedesignExtensionCardHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./RedesignExtensionCardHeader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RedesignExtensionCardHeader.vue?vue&type=style&index=0&id=41ea2b49&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports